import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[appToggle]',
})
export class ToggleDirective {
  constructor(
    private readonly elemRef: ElementRef,
    private readonly renderer: Renderer2,
  ) {}
  @HostListener('click', ['$event.target']) toggleClass(target: any) {
    if (
      this.elemRef.nativeElement.nextElementSibling.className.includes(
        'is-active',
      )
    ) {
      this.renderer.removeClass(
        this.elemRef.nativeElement.nextElementSibling,
        'is-active',
      );
      this.renderer.removeClass(this.elemRef.nativeElement, 'expand');
    } else {
      this.renderer.addClass(
        this.elemRef.nativeElement.nextElementSibling,
        'is-active',
      );
      this.renderer.addClass(this.elemRef.nativeElement, 'expand');
    }
  }
}
